import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const FilterCircleIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6654 7.9987C14.6654 4.3168 11.6806 1.33203 7.9987 1.33203C4.3168 1.33203 1.33203 4.3168 1.33203 7.9987C1.33203 11.6806 4.3168 14.6654 7.9987 14.6654C11.6806 14.6654 14.6654 11.6806 14.6654 7.9987Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M6 8H10.0001"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66797 10.332H9.33464"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33203 5.66797H10.6654"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
